import React, {Component} from "react";
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import AppBar from '@material-ui/core/AppBar';
import Tracking from "../Tracking/Tracking";
import FlightScheduleSearch from "../FlightScheduleSearch/FlightScheduleSearch";
import TrackingAdvancedSearch from '../TrackingAdvancedSearch/TrackingAdvancedSearch';
import Booking from "../Booking/Booking";
import RapidRewards from "../RapidRewards/RapidRewards";
import {Link} from "react-router-dom";


class TrackingToolsToolBar extends Component {
    state = {
        activeTool: this.props.activeTool
    };

    handleTrackingClick = () => {
        this.setState(
                {
                    activeTool: 'tracking'
                }
        );
    };

    handleFlightScheduleClick = () => {
        this.setState(
                {
                    activeTool: 'flightSchedule'
                }
        );
    };

    handleOnlineBookingClick = () => {
        this.setState(
                {
                    activeTool: 'onlineBooking'
                }
        );
    };

    handleRapidRewardsClick = () => {
        this.setState(
                {
                    activeTool: 'rapidRewards'
                }
        );
    };

    handleClick = (toolbarName) => {
        this.setState(
                {
                    activeTool: toolbarName
                }
        );
    };

    getActiveToolBar = () => {
        switch (this.state.activeTool) {
            case 'tracking':
                return <Tracking showAdvancedSearchLink={true}/>;
            case 'trackByAirWaybill':
                return <Tracking showAdvancedSearchLink={false}/>;
            case 'flightSchedule' :
                return <FlightScheduleSearch/>;
            case 'onlineBooking' :
                return <Booking/>;
            case 'rapidRewards' :
                return <RapidRewards />
            case 'advancedSearch':
                return <TrackingAdvancedSearch/>;
            default :
                return;
        }
    };

    getToolBarStyle = (toolbarName) => {
        if (toolbarName === this.state.activeTool) {
            return 'toolbar-navigation__link--active';
        }
        return "toolbar-navigation__link";
    };

    getWrapperStyle = () => {
        let wrapperStyle = 'toolstoolbar-wrapper';
        if (this.props.showAdvancedSearch === true) {
            wrapperStyle += ' toolstoolbar-wrapper-with-bottom-margin';
        }
        return wrapperStyle;
    };


    render() {

        return (
                <div className={this.getWrapperStyle()}>
                    <AppBar position="static" className="toolstoolbar-header">
                        <Toolbar className="toolstoolbar">
                            {this.props.showToolsLabel === true &&
                            <Typography variant="title" color="inherit" className="toolstoolbar__title">
                                Tools
                            </Typography>
                            }
                            <nav className="toolstoolbar-navigation">
                                {this.props.showTrackShipmet === true &&
                                <Button className={this.getToolBarStyle('tracking')} disableRipple={true}
                                        onClick={this.handleTrackingClick}>
                                    <img className="toolbar-navigation-link__icon" src="./assets/home/where-we-fly.svg"
                                         alt="Track a shipment"/> Track A Shipment
                                </Button>
                                }
                                {this.props.showFlightScheduleSearch === true &&
                                <Button className={this.getToolBarStyle('flightSchedule')} disableRipple={true}
                                        onClick={this.handleFlightScheduleClick}>
                                    <img className="toolbar-navigation-link__icon" src="./assets/home/flight-status.svg" alt="Flight schedule"/>Flight
                                    Schedules
                                </Button>
                                }
                                {this.props.showOnlineBooking === true &&
                                <Button className={this.getToolBarStyle('onlineBooking')} disableRipple={true}
                                        onClick={this.handleOnlineBookingClick}>
                                    <img className="toolbar-navigation-link__icon" src="./assets/home/online-booking.svg" alt="Online Booking"/>Online
                                    Booking
                                </Button>
                                }
                                {this.props.showRapidRewards === true &&
                                        <Button className={this.getToolBarStyle('rapidRewards')} disableRipple={true}
                                                onClick={this.handleRapidRewardsClick}>
                                            <img className="toolbar-navigation-link__icon" src="./assets/home/rapid-rewards.svg" alt="Rapid Rewards"/><span>Rapid Rewards<sup>®</sup> Cargo</span>
                                        </Button>
                                }
                                {this.props.showTrackAirWayBill === true &&
                                <Button className={this.getToolBarStyle('trackByAirWaybill')} disableRipple={true}
                                        onClick={() => this.handleClick('trackByAirWaybill')}>
                                    <img className="toolbar-navigation-link__icon" src="./assets/home/where-we-fly.svg" alt="Air waybill"/>Air Waybill Number
                                </Button>
                                }

                                {this.props.showAdvancedSearch === true &&
                                <Button className={this.getToolBarStyle('advancedSearch')} disableRipple={true}
                                        onClick={() => this.handleClick('advancedSearch')}>
                                    <img className="toolbar-navigation-link__icon" src="./assets/icons/profile.svg" alt="Advanced search"/>Advanced Search
                                </Button>
                                }



                            </nav>
                        </Toolbar>
                    </AppBar>
                    <div className="tools-selected-wrapper">
                        {this.getActiveToolBar()}
                        {this.state.activeTool === "tracking" &&
                                this.props.addEmailNotiSignUp === true &&
                                <div  class="tracking-add-another-bill">Want to be notified? Sign up for tracking emails <Link to="/manage/forms-and-applications/email-preference-form/" >here.</Link> </div>
                        }
                    </div>

                </div>
        );
    }
}

export default TrackingToolsToolBar;



// WEBPACK FOOTER //
// ./src/components/TrackingToolsToolBar/TrackingToolsToolBar.js